<template>
  <CxBadge :variant="variant">
    <CxText :fontSize="fontSize">{{ translate(`CATALOG_IMPORTS.STATUS_LABEL.${status}`) }}</CxText>
  </CxBadge>
</template>

<script setup lang="ts">
// @ts-nocheck
// TODO: This should be removed & types should be fixed in https://recommerce.atlassian.net/browse/CXCORE-7888
import { computed } from "vue";
import CxBadge from "@/designSystem/Badge/CxBadge.vue";
import ExportStatus from "@/apps/dashboard/catalog/core/domain/model/ExportStatus.enum";
import useTranslate from "@/core/composables/translate";
import { CxText } from "@/designSystem/Typography";
import { FontSizeType, TEXT_SM, TEXT_FONT_SIZES } from "@/designSystem/Typography/constant";

const { translate } = useTranslate();

const { status } = defineProps({
  status: String,
  fontSize: {
    type: String as () => FontSizeType,
    default: TEXT_SM,
    validator: (value: string) => Object.keys(TEXT_FONT_SIZES).includes(value),
  },
});

const variants: { [key: string]: string } = {
  [ExportStatus.IN_PROGRESS]: "info",
  [ExportStatus.ERROR]: "danger",
  [ExportStatus.SUCCESS_WITH_IGNORED]: "warning",
  [ExportStatus.SUCCESS]: "success",
};

const variant = computed(() => variants[status]);
</script>
